export default "__VITE_ASSET__DM1Y_KPN__"